import { useRetailStores } from '~/techstyle-shared/react-accounts';
import { useGeoLocationByIP } from '~/techstyle-shared/react-intl';

import useStoreLocation from '../utils/useStoreLocation';

const DEFAULT_SEARCH_PARAMS = {
  radius: 50,
};

export default function useDefaultStoreLocation() {
  const { storeLocation } = useStoreLocation();
  const geoLocationByIp = useGeoLocationByIP();

  const searchParams = {
    ...DEFAULT_SEARCH_PARAMS,
    ...(geoLocationByIp && geoLocationByIp.length
      ? { point: geoLocationByIp.join(',') }
      : {}),
  };

  const { results } = useRetailStores(searchParams);

  const defaultStore = storeLocation || (results?.length && results[0]);
  const hasLocation = Boolean(defaultStore);

  return {
    defaultStore,
    hasLocation,
  };
}
